export const CreateConsultationIntro = [
  // patient step
  [
    {
      element:
        '#root > div > div > div.MuiStack-root.css-1kk4p2v-MuiStack-root > div.MuiContainer-root.MuiContainer-maxWidthLg.css-p9bsua-MuiContainer-root > div.MuiStack-root.css-1dc14s1-MuiStack-root > div > div:nth-child(1)',
      intro: 'CREATE_CONSULTAION_0',
    },
    {
      element: '#search-patient',
      intro: 'CREATE_CONSULTAION_1',
    },
    {
      element: '#patient-table',
      intro: 'CREATE_CONSULTAION_2',
    },
    {
      element: '#patient-table',
      intro: 'CREATE_CONSULTAION_2_1',
    },
    {
      element: 'button[data-testid="next"]',
      intro: 'CREATE_CONSULTAION_3',
    },
  ],
  // speciality step
  [
    {
      element:
        '#root > div > div > div.MuiStack-root.css-1kk4p2v-MuiStack-root > div.MuiContainer-root.MuiContainer-maxWidthLg.css-p9bsua-MuiContainer-root > div.MuiStack-root.css-1dc14s1-MuiStack-root > div > div:nth-child(2) > span',
      intro: 'CREATE_CONSULTAION_4',
    },
    {
      element: '#speciality',
      intro: 'CREATE_CONSULTAION_5',
    },
    {
      element: '#reason',
      intro: 'CREATE_CONSULTAION_6',
    },
  ],
  // select doctor step
  [
    {
      intro: 'CREATE_CONSULTAION_7',
    },
    {
      element: '#invite-doctor',
      intro: 'CREATE_CONSULTAION_8',
    },
    {
      element: '#start-local',
      intro: 'CREATE_CONSULTAION_9',
    },
    {
      element: '#waiting-room',
      intro: 'CREATE_CONSULTAION_9_1',
    },
    {
      element: '#search-doctor',
      intro: 'CREATE_CONSULTAION_10',
    },
    {
      element: '#staff-list',
      intro: 'CREATE_CONSULTAION_11',
    },
  ],
  // confirmation step
  [
    {
      element: '#recap',
      intro: 'CREATE_CONSULTAION_12',
    },
    {
      element: '#confirmation-submit',
      intro: 'CREATE_CONSULTAION_13',
    },
  ],
]

export const CreatePatientIntro = [
  {
    intro: 'CREATE_PATIENT_1',
    element: '#carte-vitale',
  },
  {
    intro: 'CREATE_PATIENT_2',
    element: '#patientInformation',
  },
  {
    intro: 'CREATE_PATIENT_3',
    element: '#adress-information',
  },
  {
    intro: 'CREATE_PATIENT_4',
    element: '#agreement',
  },
  {
    intro: 'CREATE_PATIENT_5',
    element: '#extra-info',
  },
  {
    intro: 'CREATE_PATIENT_6',
    element: '#add-patient-button',
  },
]

export const InfoPatientIntro = [
  {
    intro: 'INFO_PATIENT_1',
  },
  {
    intro: 'INFO_PATIENT_2',
    element: '#actions',
  },
  {
    intro: 'INFO_PATIENT_3',
    element: '#start-local',
  },
  {
    intro: 'INFO_PATIENT_4',
    element: "#consent"
  },
  {
    intro: 'INFO_PATIENT_5',
    element: '#tabs'
  }
]

export const CreateExpertiseIntro = [
  {
    intro: 'CREATE_EXPERTISE_1',
    element: '#search-patient',
  },
  {
    intro: 'CREATE_EXPERTISE_2',
    element: '#patients-table',
  }
]

export const UpdateExpertiseIntro = [
  {
    intro: 'UPDATE_EXPERTISE_1',
  },
  {
    intro: 'UPDATE_EXPERTISE_2',
    element: '#service',
  },
  {
    intro: 'UPDATE_EXPERTISE_3',
    element: '#patient-data'
  },
  {
    intro: 'UPDATE_EXPERTISE_4',
    element: "#expertise-document"
  },
  {
    intro: 'UPDATE_EXPERTISE_5',
    element: "#extra-infos"
  },
  {
    intro : 'UPDATE_EXPERTISE_6',
    element: '#confirm-button'
  }
]

export const CreateMeetingLinkIntro = [
  {
    intro : 'CREATE_MEETINGLINK_1',
    element: "#name"
  },
  {
    intro : 'CREATE_MEETINGLINK_2',
    element: "#description"
  },
  {
    intro : 'CREATE_MEETINGLINK_3',
    element: "#specialities"
  },
  {
    intro : 'CREATE_MEETINGLINK_4',
    element: '#staff-selection'
  }
]

export const ViewMeetingLinkIntro = [
  {
    element:'#meeting-link-list',
    intro: 'VIEW_MEETINGLINK_1'
  },
  {
    element: '#orders-list',
    intro: 'VIEW_MEETINGLINK_2'
  }
]


export const CreateAvailabilityIntro = [
  {
    intro: 'CREATE_AVAILABILITY_1',
    element: "#specialities"
  },
  {
    intro: 'CREATE_AVAILABILITY_2',
    element: "#adress"
  },
  {
    intro: 'CREATE_AVAILABILITY_3',
    element : "#scheduleD"
  }
]


export const CreateWaitingRoomIntro = [
  {
    intro: 'CREATE_WAITINGROOM_1',
    element: "#name"
  },
  {
    intro : 'CREATE_WAITINGROOM_2',
    element: "#description"
  },
  {
    intro : 'CREATE_WAITINGROOM_3',
    element: "#meetings"
  },
  {
    intro : 'CREATE_WAITINGROOM_4',
    element: "#hours"
  }
]


export const DiagnoticLocalIntro = [
  {
    intro: 'DIAGNOSTIC_LOCAL_1',
  },
  {
    element: '#mesures',
    intro: 'DIAGNOSTIC_LOCAL_5'
  },
  {
    element: '#medicalVideo',
    intro: 'DIAGNOSTIC_LOCAL_6'
  },
  {
    element: '#biologicals',
    intro: 'DIAGNOSTIC_LOCAL_7'
  },
  {
    element: '#stethoscope',
    intro: 'DIAGNOSTIC_LOCAL_8'
  },
  {
    element: '#patient-sidebar',
    intro: 'DIAGNOSTIC_LOCAL_3'
  },
  {
    element: '#patientInfo',
    intro: 'DIAGNOSTIC_LOCAL_9'
  }, 
  {
    element: '#documents',
    intro: 'DIAGNOSTIC_LOCAL_10'
  },
  {
    element: '#consultations',
    intro: 'DIAGNOSTIC_LOCAL_11'
  },
  {
    element: '#transcriptions',
    intro: 'DIAGNOSTIC_LOCAL_12'
  },
  {
    element: '#root > div > div.MuiStack-root.css-3ba8n7-MuiStack-root > div.MuiBox-root.css-9a7vyu > div > div.sash-container.allotment-module_sashContainer__fzwJF > div',
    intro: 'DIAGNOSTIC_LOCAL_13'

  }
]

export const DiagnoticLiveIntro = [
  {
    intro: 'DIAGNOSTIC_LIVE_1',
  },
  {
    element: '#expand-button',
    intro: 'DIAGNOSTIC_LOCAL_4'
  },
  {
    element: '#patientInfo',
    intro: 'DIAGNOSTIC_LOCAL_9'
  },
  {
    element: '#mesures',
    intro: 'DIAGNOSTIC_LIVE_4'
  },
  {
    element: '#documents',
    intro: 'DIAGNOSTIC_LOCAL_10'
  },
  {
    element: '#transcriptions',
    intro: 'DIAGNOSTIC_LOCAL_12'
  },
  {
    element: '#root > div > div.MuiStack-root.css-3ba8n7-MuiStack-root > div.MuiBox-root.css-9a7vyu > div > div.sash-container.allotment-module_sashContainer__fzwJF > div',
    intro: 'DIAGNOSTIC_LOCAL_13'
  },
  {
    element: '#invite-button',
    intro: 'DIAGNOSTIC_LIVE_2'
  },
  {
    element: '#chat-button',
    intro: 'DIAGNOSTIC_LIVE_3'
  }
]

export const ViewConsultationsIntro = [
  {
    intro: 'VIEW_CONSULTATIONS_1',
  },
  {
    element: '#consultation-search-form',
    intro: 'VIEW_CONSULTATIONS_2'
  },
  {
    element: '#consultations-table',
    intro: 'VIEW_CONSULTATIONS_3'
  },
  {
    intro: 'VIEW_CONSULTATIONS_4',
  }
]